export const queryKeys = {
  getUserLookups: "getUserLookups",
  saveUser: "saveUser",
  getUser: "getUser",
  getAllUsers: "searchUsers",
  deleteUser: "deleteUser",
  getUserClaims: "getUserClaims",
  getRoleClaims: "getRoleClaims",
};
export const USER_STATUS_LOOKUP_TYPE_ID = "0440AE06-B67F-ED11-9DE2-00155D112818";
export const ORGANIZATION_ADMIN = "4D839D82-EA47-4A16-AB5C-4830B5F95D3F";
export const CORP_EMPLOYEE = "C3897104-3CE1-48AF-99C3-604EF66AC64C";
export const SYSTEM_ADMIN = "54023CBF-C091-4633-A139-35259EEF0D68";
export const SUPER_ADMIN = "00AC21D2-23ED-4150-AF52-445D0A635AD9"
